import MuiSwitch, { SwitchProps } from "@mui/material/Switch";

const Switch: React.FC<SwitchProps> = (props) => {
  return <MuiSwitch {...props} />;
};

export default Switch;
